module.exports = __webpack_public_path__ + "img/assess-trigger.ecde6401.svg";